/**
 * Domain enums and string-literal unions.
 *
 * These are the only allowed values for their respective fields. Anything else
 * is a bug or a malicious client and must be rejected by validation.
 */
// ---------------------------------------------------------------------------
// Users
// ---------------------------------------------------------------------------
export const USER_ROLES = ['employee', 'admin'];
/**
 * Currencies an employee can be paid in.
 * NOTE: This is intentionally restricted — distinct from `receiptCurrency`
 * on a line item, which accepts any ISO 4217 code.
 */
export const PAYOUT_CURRENCIES = [
    'EUR',
    'CHF',
    'USD',
    'GBP',
    'CLP',
    'MXN',
    'BRL',
];
export const EMPLOYMENT_TYPES = [
    'Employed',
    'External Employed',
    'Oyster',
    'Remote',
    'Agent',
    'External',
    'External Collaborator',
];
/** Common emergency-contact relationships for the dropdown. "Other" reveals a
 *  free-text field (the stored value is then the typed text, not "Other"). */
export const EMERGENCY_CONTACT_RELATIONSHIPS = [
    'Partner',
    'Spouse',
    'Parent',
    'Child',
    'Sibling',
    'Relative',
    'Friend',
    'Other',
];
/**
 * Employment types whose user has NO `@daaily.com` mailbox (e.g. a Cloud
 * Identity Free login). For these a `notificationEmail` (their real external
 * inbox) is REQUIRED — admin save is blocked without it, and submitter-facing
 * tool emails route there instead of the mailbox-less `@daaily.com` address.
 */
export const MAILBOXLESS_EMPLOYMENT_TYPES = [
    'External Collaborator',
];
/** Informational only — does not gate any behavior. */
export const GENDERS = ['male', 'female', 'other'];
export const ELIGIBILITY_TYPES = ['General', 'Fair', 'No'];
// ---------------------------------------------------------------------------
// Statements
// ---------------------------------------------------------------------------
export const STATEMENT_STATUSES = [
    'new',
    'submitted',
    'pending_2nd_approval',
    'approved',
    'rejected',
];
export function toSubmitterStatus(status) {
    switch (status) {
        case 'new':
            return 'New';
        case 'submitted':
        case 'pending_2nd_approval':
            return 'Submitted';
        case 'approved':
            return 'Approved';
        case 'rejected':
            return 'Rejected';
    }
}
// ---------------------------------------------------------------------------
// Line items
// ---------------------------------------------------------------------------
export const LINE_ITEM_TYPES = ['expense', 'travel_allowance'];
export const EXPENSE_TYPES = [
    'Accommodation',
    'Bus',
    'Taxi/Uber',
    'Plane',
    'Train / Underground',
    'Parking / Road Tolls',
    'Phone reimbursement',
    'Client hosting expenses',
    'Other expenses',
];
/** Expense type that requires a free-text business reason. */
export const EXPENSE_TYPE_REQUIRING_REASON = 'Other expenses';
export const FX_RATE_SOURCES = [
    'ECB',
    'frankfurter',
    'walkback',
    'direct',
    'same-currency',
    'manual',
];
/**
 * FX status flag on a line item. 'pending_admin' means submission was allowed
 * without a rate; accounting must enter a manual rate before approving.
 * (Decision: spec answer Q7 — least flow disruption, accounting controls.)
 */
export const FX_RATE_STATUSES = ['resolved', 'pending_admin'];
// ---------------------------------------------------------------------------
// Travel allowance day breakdown
// ---------------------------------------------------------------------------
export const TRAVEL_DAY_TYPES = [
    /** A 24-hour day fully spent away — the trip's middle days. */
    'full_day',
    /** A partial day — first or last day of the trip, when departing or returning mid-day. */
    'travel_day',
];
//# sourceMappingURL=enums.js.map